import React from 'react';
import SelectCourse from './SelectCourse';

const NewAll = props => (
  <SelectCourse
    {...props}
    design="rts"
    forcedPlatform={props.params.platform || 'all'}
  />
);

export default NewAll;
